import { Modal } from "@/components/ui/modal";
import { Search, Pencil, ChevronRight, Library } from "lucide-react";
import { useI18n } from '@/hooks/useI18n';

interface AccommodationChoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onChooseManual: () => void;
  onChooseRateHawk: () => void;
  onChooseLibrary: () => void;
}

export function AccommodationChoiceModal({
  isOpen,
  onClose,
  onChooseManual,
  onChooseRateHawk,
  onChooseLibrary,
}: AccommodationChoiceModalProps) {
  const { t } = useI18n();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('builder.addAccommodation')} size="sm">
      <div className="p-4 flex flex-col gap-3">
        <button
          onClick={onChooseRateHawk}
          className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 text-left w-full transition-colors hover:bg-gray-50"
        >
          <Search className="h-6 w-6 text-gray-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{t('builder.fromBookingPortal')}</p>
            <p className="text-sm text-gray-500 mt-0.5">{t('builder.searchAndBook')}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
        </button>

        <button
          onClick={onChooseManual}
          className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors text-left w-full"
        >
          <Pencil className="h-5 w-5 text-gray-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{t('builder.addManually')}</p>
            <p className="text-sm text-gray-500 mt-0.5">{t('builder.addManuallyDescription')}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
        </button>

        <button
          onClick={onChooseLibrary}
          className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors text-left w-full"
        >
          <Library className="h-5 w-5 text-gray-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{t('library.chooseFromLibraryAction')}</p>
            <p className="text-sm text-gray-500 mt-0.5">{t('library.chooseFromLibraryDescription')}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
        </button>
      </div>
    </Modal>
  );
}
